import axios from "axios";
import { getToken } from "./auth";

// export const baseURL = "http://localhost:8005";
export const baseURL = "https://tti-backend.siglonet.com";

// export const filesURL = "http://localhost:8005/temporary";
export const filesURL = "https://tti-backend.siglonet.com/public/temporary";

const api = axios.create({
  baseURL: baseURL + "/api",
});

api.interceptors.request.use(async (config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
